import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModifyMotorsComponent } from './modify-motors.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { modifyMotorsOccConfig } from './core/modify-motors.occ';

@NgModule({
  declarations: [ModifyMotorsComponent],
  imports: [CommonModule, I18nModule],
  providers: [
    provideConfig(modifyMotorsOccConfig),
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ModifyMotors: {
          component: ModifyMotorsComponent,
        },
      },
    }),
  ],
})
export class ModifyMotorsModule {}
